// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from '../../core/components/UserComponent';
import PositionMarker from '../../level/editor/PositionMarker';
/* START-USER-IMPORTS */
import PlatformContainer from '../../level/PlatformContainer';
import PlatformImage from '../../level/platforms/PlatformImage';
import MoverData from './MoverData';
/* END-USER-IMPORTS */

export default class SimpleMover extends UserComponent {
  constructor(gameObject: PlatformImage | PlatformContainer) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)['__SimpleMover'] = this;

    /* START-USER-CTR-CODE */
    this.hasStarted = false;

    this.isMoving = false;
    this.isAtStart = true;

    this.gameObject.IsMovingPlatform = true;

    this.gameObject.on(PlatformImage.events.Init, this.init, this);
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: PlatformImage | PlatformContainer): SimpleMover {
    return (gameObject as any)['__SimpleMover'];
  }

  // static clearComponent(gameObject: PlatformImage | PlatformContainer) {
  //   gameObject.IsMovingPlatform = false;
  //   delete (gameObject as any)['__SimpleMover'];
  // }

  private gameObject: PlatformImage | PlatformContainer;
  public startPoint!: Phaser.Geom.Point;
  public endPoint!: Phaser.Geom.Point;
  public startWait: number = 0;
  public endWait: number = 0;
  public initialDelay: number = 0;

  /* START-USER-CODE */
  protected hasStarted: boolean;
  protected isMoving: boolean;
  protected isAtStart: boolean;
  protected movingTween: Phaser.Tweens.Tween | undefined;

  public setFromMoverData(moverData: MoverData) {
    this.startPoint = new Phaser.Geom.Point(moverData.startMarker.x, moverData.startMarker.y);
    this.endPoint = new Phaser.Geom.Point(moverData.endMarker.x, moverData.endMarker.y);
    this.startWait = moverData.startWait;
    this.endWait = moverData.endWait;
    this.initialDelay = moverData.initialDelay;
  }

  // public deactivate() {
  //   this.scene.tweens.killTweensOf(this);
  //   this.isMoving = false;
  //   this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.start, this);
  //   this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
  // }

  // Shift the platform by an X and Y offset.
  public shift(offsetX: number, offsetY: number) {
    this.startPoint.x += offsetX;
    this.startPoint.y += offsetY;

    this.endPoint.x += offsetX;
    this.endPoint.y += offsetY;

    this.gameObject.x += offsetX;
    this.gameObject.y += offsetY;

    if (this.isMoving && this.movingTween) {
      let targetX = this.isAtStart ? this.startPoint.x : this.endPoint.x;
      let targetY = this.isAtStart ? this.startPoint.y : this.endPoint.y;
      // let wait = this.isAtStart ? this.endWait : this.startWait;

      // this.movingTween?.updateTo('x', targetX, false);
      // this.movingTween?.updateTo('y', targetY, false);

      let duration = this.movingTween.hasStarted ? this.movingTween.duration - this.movingTween.elapsed : 2000;
      let delay = this.movingTween.hasStarted ? 0 : this.movingTween.startDelay;

      this.scene.tweens.killTweensOf(this.gameObject);

      this.move(targetX, targetY, duration, delay);
    }
  }

  protected init(): void {
    console.log('Component Init');

    if (this.startPoint) {
      this.gameObject.x = this.startPoint.x;
      this.gameObject.y = this.startPoint.y;
    }
  }

  protected awake() {
    console.log('Component Awake');
  }

  protected update(time: number, delta: number) {
    if (!this.hasStarted) {
      this.initialDelay -= delta;

      if (this.initialDelay > 0) return;

      this.hasStarted = true;
    }

    if (!this.isMoving && this.isAtStart) {
      this.isAtStart = false;
      this.isMoving = true;
      this.move(this.endPoint.x, this.endPoint.y, 2000, this.startWait);
      return;
    } else if (!this.isMoving && !this.isAtStart) {
      this.isAtStart = true;
      this.isMoving = true;
      this.move(this.startPoint.x, this.startPoint.y, 2000, this.endWait);
      return;
    }
  }

  protected move(targetX: number, targetY: number, duration: number, delay: number) {
    if (this.gameObject.active) {
      this.movingTween = this?.gameObject?.scene?.add?.tween({
        targets: this.gameObject,
        x: targetX,
        y: targetY,
        duration: duration,
        ease: Phaser.Math.Easing.Cubic,
        onComplete: () => {
          this.isMoving = false;
          this.movingTween = undefined;
        },
        delay: delay
      });
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
